import { defineMessages } from "react-intl";

export default defineMessages({
  labelNotes: {
    id: "AppointmentNote.AppointmentTechnologistNoteEditDialogContainer.labelnotes",
    defaultMessage: "Notes",
  },
});
